<script lang="ts">
    import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-svelte';
    import Button from '../ui/button/button.svelte';
    import type { Data } from './index.js';
    import type { rowCountOptions as rowCount } from '@/lib/optionsLists';
    import Select from '@/components/Inputs/Select.svelte';
    import type { Snippet } from 'svelte';

    type Props = {
        offset: number;
        limit: number;
        data: Data | null;
        fetchData: () => void;
        rowCountOptions?: typeof rowCount;
        children?: Snippet;
    };
    let {
        offset = $bindable(),
        limit = $bindable(),
        data,
        fetchData,
        rowCountOptions,
        children,
    }: Props = $props();
</script>

<div class="flex w-full flex-wrap items-center justify-center gap-4 p-4">
    <Select
        label="Rows"
        labelDir="left"
        options={rowCountOptions}
        bind:value={
            () => limit,
            (val) => {
                limit = val;
                fetchData();
            }
        }
        class="max-w-[120px]"
    />
    <Button
        disabled={offset < 1}
        onclick={() => {
            offset = Math.max(offset - limit, 0);
            fetchData();
        }}
    >
        <ArrowLeftIcon></ArrowLeftIcon>
    </Button>
    <p class="shgrid_pkg-paginator_p">
        {offset + 1} - {Math.min(offset + limit, data?.count ?? offset + limit)}{data?.count !==
    undefined
        ? ` of ${data.count}`
        : ''}
    </p>
    <Button
        disabled={data ? offset + limit >= data.count : true}
        onclick={() => {
            offset += limit;
            fetchData();
        }}
    >
        <ArrowRightIcon></ArrowRightIcon>
    </Button>
    {@render children?.()}
</div>
